import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'ko', label: '한국어' },
  { code: 'en', label: 'English' },
];

const LangSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const current = LANGS.find(l => l.code === i18n.language) || LANGS[0];

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const select = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div ref={ref} style={styles.wrap}>
      <button style={styles.trigger} onClick={() => setOpen(o => !o)}>
        <span style={styles.label}>{current.code.toUpperCase()}</span>
        <span style={{ fontSize: 10, color: '#999' }}>{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <div style={styles.dropdown}>
          {LANGS.map(lang => (
            <button
              key={lang.code}
              style={{
                ...styles.option,
                ...(lang.code === i18n.language ? styles.optionActive : {}),
              }}
              onClick={() => select(lang.code)}
            >
              <span>{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  wrap: { position: 'relative' },
  trigger: {
    display: 'flex', alignItems: 'center', gap: 4,
    padding: '5px 10px', background: '#fafafa',
    border: '1px solid #e8e8e8', borderRadius: 20,
    cursor: 'pointer', fontSize: 13, fontWeight: 500,
  },
  label: { color: '#555' },
  dropdown: {
    position: 'absolute', top: '110%', right: 0,
    background: '#fff', border: '1px solid #e8e8e8',
    borderRadius: 10, boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
    minWidth: 130, zIndex: 200, overflow: 'hidden',
  },
  option: {
    display: 'flex', alignItems: 'center', gap: 8,
    width: '100%', padding: '10px 14px',
    background: 'none', border: 'none',
    cursor: 'pointer', fontSize: 13, color: '#333',
    textAlign: 'left',
  },
  optionActive: { background: '#f3ecfb', color: '#b39ddb', fontWeight: 600 },
};

export default LangSwitcher;
